import { render, staticRenderFns } from "./CenterSearchDialog.vue?vue&type=template&id=5704c3b2&scoped=true"
import script from "./CenterSearchDialog.vue?vue&type=script&lang=js"
export * from "./CenterSearchDialog.vue?vue&type=script&lang=js"
import style0 from "./CenterSearchDialog.vue?vue&type=style&index=0&id=5704c3b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5704c3b2",
  null
  
)

export default component.exports